import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiFormLabel-root': {
      color: theme.palette.grey9,
      ...theme.rccl.labelMicro,
    },
    '& .MuiInput-input': {
      ...{
        background: theme.palette.grey4,
        height: theme.typography.pxToRem(36),
        opacity: 1,
        padding: `0 ${theme.typography.pxToRem(10)} 0 0`,
      },
      ...theme.rccl.body2,
    },
    '& .MuiInputBase-root': {
      background: theme.palette.grey4,
      border: `1px solid ${theme.palette.grey4}`,
    },
    '& .MuiInputAdornment-root': {
      background: theme.palette.grey4,
      height: 'auto',
      margin: '0',
      overflow: 'visible',
      width: '40px',
    },
    '& .MuiButtonBase-root': {
      display: 'inline-block',
      margin: '0 auto',
    },
    '& div.Mui-focused, &.icon-focused .MuiInput-root': {
      border: `1px solid ${theme.palette.blue2}`,
    },
    '& .MuiFormHelperText-root': {
      color: theme.palette.blue2,
      fontSize: theme.typography.pxToRem(10),
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: theme.palette.critical,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(18),
    },
    '&.touched .MuiInput-input': {
      color: theme.palette.grey1,
    },
    [theme.breakpoints.down('xs')]: {
      '& .MuiFormHelperText-root': {
        display: 'none',
        '&.Mui-error': {
          display: 'block',
        },
      },
    },
  },
  dialog: {
    '& .MuiToolbar-root': {
      background: 'white',
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    '& h6.MuiTypography-root': {
      fontSize: theme.typography.pxToRem(16),
      letterSpacing: '0',
      lineHeight: theme.typography.pxToRem(18),
    },
    '& h6.MuiTypography-root, & .MuiPickersDay-day, & .MuiPickersYear-root': {
      color: theme.palette.blue2,
    },
    '& h4.MuiTypography-root, &.MuiTypography-body1, & .MuiPickersYear-yearSelected': {
      color: theme.palette.blue1,
    },
    '& h4.MuiTypography-root': {
      textTransform: 'capitalize',
    },
    '& .MuiTypography-body1, & .MuiPickersCalendarHeader-daysHeader': {
      fontFamily: theme.typography.proxima.regular,
      textTransform: 'capitalize',
    },
    '& .MuiSvgIcon-root': {
      fill: theme.palette.blue2,
    },
    '& .MuiPickersDay-daySelected': {
      color: 'white',
      backgroundColor: theme.palette.blue2,
    },
    '& .MuiPickersDay-dayDisabled, & .MuiPickersCalendarHeader-dayLabel': {
      color: theme.palette.grey2,
    },
    '& .MuiButton-textPrimary': {
      color: theme.palette.blue2,
    },
  },
}));
